import { toast } from 'sonner';

// Role-based visibility utility
export const canAccess = (
  userRole: string,
  requiredRoles: string[]
): boolean => {
  return requiredRoles.includes(userRole);
};

// Format date utility
export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

// Show toast notifications
export const showToast = (
  type: 'success' | 'error' | 'info',
  message: string
) => {
  toast[type](message);
  // Add console logging for debugging
  console.log(`[${type.toUpperCase()}] ${message}`);
};

// Merge objects deeply
export const deepMerge = (target: any, source: any) => {
  const result = { ...target };

  for (const key in source) {
    if (source[key] instanceof Object && key in target) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }

  return result;
};

// Sort array by property
export const sortByProperty = <T>(
  array: T[],
  property: keyof T,
  ascending = true
): T[] => {
  return [...array].sort((a, b) => {
    const valA = a[property];
    const valB = b[property];

    if (valA < valB) return ascending ? -1 : 1;
    if (valA > valB) return ascending ? 1 : -1;
    return 0;
  });
};

// Convert string to title case
export const toTitleCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
